import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions } from './index';
import { PaginationProps } from '../types';
import { UserRole, UserStatus } from '../auth';

export type UserListData = AnyObject

export type UserListResponse = UserListData
export type UserListColumns = 'id' | 'role' | 'name' | 'email' | 'phone' | 'status' | 'createdAt' | 'updatedAt';

export type UserListGetParams = PaginationProps<UserListColumns> & {
  roles?: UserRole[];
  email?: string;
  zipCode?: string;
  yearBirth?: number | null;
  name?: string;
  status?: UserStatus;
  countryId?: number | null;
  categoryId?: string | null;
  subCategoryId?: string | null;
  search?: string;
  // isEmailVerified?: boolean;
  // isPhoneVerified?: boolean;
}

export const userList = (payload: UserListGetParams): Action<UserListGetParams> => ({
  type: actions.userListTrigger.toString(),
  payload,
});

export const userListClear = (): Action => ({
  type: actions.userListClear.toString(),
});

export const userListErrorClear = (): Action => ({
  type: actions.userListErrorReset.toString(),
});

export function* userListRequestSaga({ payload }: Action<UserListGetParams>) {
  yield put({
    type: actions.userListStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.userListError.toString(),
      payload: {
        message: 'UserList: Parameters not passed.',
      },
    });

    return;
  }

  const { roles, ...restParams } = payload;

  const params = new URLSearchParams(Object.entries(restParams).filter((entry) => !!entry[1]));

  if (Array.isArray(roles) && roles?.length) {
    // eslint-disable-next-line unicorn/consistent-destructuring
    payload.roles?.forEach((role: UserRole) => params.append('roles', role));
  } else if (roles) {
    params.append('roles', roles.toString());
    params.append('roles', roles.toString());
  }

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/users?${params.toString()}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<UserListData, UserListResponse>(
    response,
    actions.userListSuccess.toString(),
    actions.userListError.toString(),
    false,
    (userListData) => userListData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.userListTrigger.toString(),
    defaultProcessingSaga(
      userListRequestSaga,
      {
        error: actions.userListError.toString(),
        locationCancel: actions.userListClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.userListSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.userListError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.userListErrorReset.toString(),
    });
  });
}
